<template>
    <div class="sidebar sidebar-active" ref="dashboardSidebar">
      <div class="logo-content">
        <div class="logo">
            <img
              class="logo-image"
              v-bind:src="logoSrc"
              alt="Sidebar Logo"
            />
            <div class="logo-name">{{ logoName }}</div>
        </div>
        <i class="fas fa-bars menu-button" @click="toggleSidebar"></i>
      </div>
      <ul class="nav-list">
        <li v-for="navItem of navigationList" v-bind:key="navItem.text">
          <div class="search-image-container" v-if="navItem.type === 'input'">
            <img class="search-image" v-bind:src="navItem.icon">
          </div>
          <input v-if="navItem.type === 'input'" type="text" v-bind:placeholder="navItem.text" disabled>
          <router-link v-if="navItem.type === 'link'" v-bind:to="navItem.path" v-bind:class="{ [`link-active`]: $route.path.includes(navItem.path) }">
            <i v-bind:class="navItem.icon"></i>
            <span class="link-text">{{ navItem.text }}</span>
          </router-link>
          <span class="tooltip">{{ navItem.tooltipText }}</span>
        </li>
      </ul>
    </div>
</template>

<script>
export default {
  name: "Sidebar",
  props: ["logoSrc", "logoName", "navigationList"],
  methods: {
    toggleSidebar() {
      const sidebar = this.$refs.dashboardSidebar;
      sidebar.classList.toggle("sidebar-active");
      this.$emit("sidebar-toggle");
    }
  },
  mounted() {
    if (window.innerWidth < 651) this.toggleSidebar();
  }
}
</script>

<style>
:root {
  --small-border-radius: 0.5em;
  --sidebar-open-width: 265px;
  --sidebar-closed-width: 93px;
  --sidebar-closed-button-width: 55px;
  --sidebar-open-button-width: 95.5%;
  --sidebar-animation-duration: 0.5s;
}

body {
  position: relative;
  min-height: 100vh;
  width: 100%;
}

.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  min-height: 100%;
  width: var(--sidebar-closed-width);
  background: var(--black-blue);
  padding: 6px 14px;
  transition: all var(--sidebar-animation-duration);
  z-index: 500;
}

.sidebar.sidebar-active {
  width: var(--sidebar-open-width);
}

.sidebar .logo-content {
  position: relative;
  left: 0.45em;
  top: 0.6em;
}

.sidebar .logo-content .logo {
  color: var(--white);
  display: flex;
  height: 3em;
  width: 100%;
  align-items: center;
  opacity: 0;
  pointer-events: none;
  transition: opacity .1s;
}

.sidebar.sidebar-active .logo {
  opacity: 1;
  transition: opacity .2s;
  transition-delay: var(--sidebar-animation-duration);
}

.sidebar .logo-content .logo .logo-image {
  width: 2.5em;
  height: 2.5em;
  margin-right: 0.7em;
}

.sidebar .logo-content .logo .logo-name {
  font-size: 1.4em;
  font-weight: 400;
}

.sidebar .logo-content .menu-button {
  font-size: 20px;
  color: var(--white);
  position: absolute;
  left: 50%;
  top: -1px;
  height: 2.5em;
  width: 2.5em;
  text-align: center;
  line-height: 2.5em;
  transform: translateX(-65%);
  cursor: pointer;
  transition: 0.5s;
}

.sidebar.sidebar-active .logo-content .menu-button {
  left: 90%;
  transition: 0.7s;
}

.sidebar ul {
  margin-top: 1.5em;
}

.sidebar ul li {
  list-style-type: none;
  position: relative;
  height: 3.5em;
  margin: 0 0.3em;
  width: 100%;
  line-height: 3.5em;
  max-width: var(--sidebar-closed-button-width);
}

.sidebar.sidebar.sidebar-active ul li {
  max-width: var(--sidebar-open-button-width);
}

.sidebar ul li input {
  font-size: 1em;
  position: absolute;
  height: 100%;
  left: 0;
  top: 0;
  outline: none;
  border: none;
  background-color: transparent;
  padding-left: 3em;
  color: transparent;
  width: var(--sidebar-closed-button-width);
  transition: all 0.2s;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: not-allowed;
}

.sidebar ul li input::placeholder {
  opacity: 0;
  transition: opacity 0.2s;
}

.sidebar.sidebar-active ul li input::placeholder {
  opacity: 1;
  transition: opacity 0.2s;
  color: var(--plain-gray);
  font-variant-caps: all-petite-caps;
  font-size: 1.2em;
  font-weight: 700;
}

.sidebar.sidebar-active ul li input {
  width: 100%;
  color: var(--white);
  transition: all 0.2s;
}

.sidebar ul li .search-icon {
  position: absolute;
  z-index: 99;
  color: var(--white);
  font-size: 22px;
  left: 0;
  height: 100%;
  border-radius: 0.4em;
  rotate: -90deg;
}

.sidebar.sidebar-active ul li .search-icon:hover {
  background-color: transparent;
  color: var(--white)
}

.sidebar ul li a {
  color: var(--white);
  display: flex;
  align-items: center;
  text-decoration: none;
  transition: all 0.4s ease;
  border-radius: var(--small-border-radius);
  white-space: nowrap;
}

.sidebar ul li a:hover {
  background-color: var(--grey-blue);
}

.sidebar ul li a.link-active {
  color: var(--black-blue);
  background-color: var(--white);
}

.sidebar ul li a .link-text {
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s;
}

.sidebar.sidebar-active ul li a .link-text {
  opacity: 1;
  visibility: visible;
  transition: opacity 75ms;
  transition-delay: 0.25s;
}

.sidebar ul li i {
  font-size: 20px;
  height: 2.5em;
  min-width: 2.5em;
  border-radius: var(--small-border-radius);
  line-height: 2.5em;
  text-align: center;
  position: relative;
  left: 0.1em;
}

.sidebar ul li:not(:last-child) {
  margin-bottom: 0.3em;
}

.sidebar .profile-conent {
  position: absolute;
  color: var(--white);
  bottom: 0;
  left: 0;
  width: 100%;
}

.sidebar .profile-conent .profile {
  position: relative;
  padding: 0.7em 0.3em;
  height: 4.5em;
  background-color: var(--grey-blue);
}

.sidebar .profile-conent .profile .profile-details {
  display: flex;
  align-items: center;
}

.sidebar .profile-conent .profile .profile-details img {
  height: 3em;
  width: 3em;
  object-fit: cover;
  border-radius: var(--small-border-radius);
}

.sidebar .profile-conent .profile .profile-details .name-role {
  margin-left: 0.55em;
}

.sidebar .profile-conent .profile .profile-details .name-role .name {
  font-size: 0.85em;
  font-weight: 400;
}

.sidebar .profile-conent .profile .profile-details .name-role .job {
  font-size: 0.65em;
  font-weight: 400;
}

.logout-button {
  position: absolute;
  left: 85%;
  bottom: 0.3em;
  transform: translateX(-50%);
  min-width: 3.2em;
  line-height: 3.2em;
  font-size: 20px;
  border-radius: var(--small-border-radius);
}

.sidebar ul li .tooltip {
  position: absolute;
  height: 2.5em;
  width: 11em;
  left: 10em;
  transform: translate(-40%, -50%);
  top: 50%;
  background: var(--white);
  box-shadow: 0 0.3em 0.6em var(--shadow-dark);
  border-radius: var(--small-border-radius);
  line-height: 2.5em;
  color: var(--black-blue);
  transition: 0s;
  text-align: center;
  opacity: 0;
  pointer-events: none;
  z-index: 2000;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sidebar ul li .search-image-container {
  position: absolute;
  z-index: 99;
  background-color: transparent;
  width: 3.5em;
  height: 3.5em;
  display: flex;
  justify-content: center;
  align-items: center;
}

.sidebar ul li .search-image-container .search-image {
  width: 100%;
  height: 100%;
  border-radius: var(--small-border-radius);
  transition: all var(--sidebar-animation-duration);
}

.sidebar.sidebar-active ul li .search-image-container .search-image {
  width: 20px;
  height: 20px;
  transition: all var(--sidebar-animation-duration);
  border-radius: calc(var(--small-border-radius) - 0.2em);
}

.sidebar ul li:hover .tooltip {
  position: absolute;
  transition: all 0.5s ease;
  left: 8em;
  opacity: 1;
}

.sidebar.sidebar-active ul li:hover .tooltip {
  display: none;
}

@media only screen and (max-width: 650px) {
  .sidebar {
    position: absolute;
  }

  .sidebar.sidebar-active {
    box-shadow: 2px 0 100px var(--black-blue);
  }
}
</style>